<template>
  <div>
    <v-card elevation="2" class="pa-3">
      <v-form v-model="valid" ref="form">
        <PageTitle icon="mdi-pencil-box-outline" main="Gestão" sub="Unidades e administrativas"
          home='/gestao-da-camara' />
        <input id="user-id" type="hidden" v-model="unidade.usuario" />
        <input id="unidade-id" type="hidden" v-model="unidade.id" />
        <input id="unidade-uuid" type="hidden" v-model="unidade.uuid" />
        <v-row>
          <v-col cols="12" md="2">
            <v-text-field v-model="unidade.id" label="Código" outlined dense>
              <v-icon slot="append" color="success" large @click="loadDialog">
                mdi-magnify
              </v-icon>
            </v-text-field>
          </v-col>
          <v-col cols="12" md="2" v-if="unidade.id">
            <v-checkbox v-model="unidade.inativar" label="Inativar Página ?" color="success"
              v-show="mode === 'save'">
            </v-checkbox>
          </v-col>
          <v-col cols="12" md="6" lg="4">
            <v-autocomplete v-model="unidade.parentId" :items="parent" label="Selecione a unidade principal" clearable
              dense outlined hint="* Deixe em branco para criar unidade primária" persistent-hint></v-autocomplete>
          </v-col>
        </v-row>
        <!-- Impementação de código, add categoria e subcategoria -->
        <v-row>
          <v-col cols="12" md="4">
            <v-autocomplete v-model="unidade.uid_categoria" :items="categorias" hide-selected dense outlined
              @blur="loadSubCategorias(cat = unidade.uid_categoria)" label="Categoria da unidade">
              <v-icon class="mr-2" slot="append" color="black" v-if="unidade.uid_categoria"
                @click.prevent="limparBoxes()">
                mdi-close
              </v-icon>
              <v-btn class="btn-outer  ml-2 pa-0" slot="append" color="success" tile @click="dialogCategoria">
                <v-icon class="mx-0" color="white">
                  mdi-magnify
                </v-icon>
              </v-btn>
              <v-btn class="btn-outer-right pa-0" slot="append" color="light" tile
                :disabled="Boolean(unidade.uid_categoria)" @click="loadAddCategoria">
                <v-icon class="mx-0" color="black">
                  mdi-plus
                </v-icon>
              </v-btn>
            </v-autocomplete>
          </v-col>
          <v-col cols="12" md="4">
            <v-autocomplete v-model="unidade.uid_subcategoria" :items="subcategorias" clearable dense outlined
              label="Subcategoria da unidade" :disabled="!unidade.uid_categoria">
              <v-btn class="btn-outer pa-0" slot="append" color="success" tile @click="dialogCategoria">
                <v-icon class="mx-0" color="white">
                  mdi-magnify
                </v-icon>
              </v-btn>
              <v-btn class="btn-outer-right pa-0" slot="append" color="light" tile @click="loadAddSubCategoria">
                <v-icon class="mx-0" color="black">
                  mdi-plus
                </v-icon>
              </v-btn>
            </v-autocomplete>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="4">
            <v-text-field v-model="unidade.slug" label="slug da unidade" outlined required dense
              hint="Exemplo: secretaria-de-administracao"></v-text-field>
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field v-model="unidade.nome_comum" label="Nome da curto" outlined required dense></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="6">
            <v-text-field v-model="unidade.unidade" label="Nome completo da unidade" outlined required
              dense></v-text-field>
          </v-col>
          <v-col cols="12" md="2">
            <v-text-field v-model="unidade.cnpj" v-mask="cnpj" label="Cnpj" outlined required dense></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="4">
            <v-text-field v-model="unidade.endereco" label="Endereço" outlined required dense></v-text-field>
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field v-model="unidade.atendimento" label="Horário de funcionamento" outlined required
              dense></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="3">
            <v-text-field v-model="unidade.fone" v-mask="fone1" label="Telefone" outlined required dense></v-text-field>
          </v-col>
          <v-col cols="12" md="1">
            <v-text-field v-model="unidade.tridigito" label="Tridigito" outlined required dense></v-text-field>
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field v-model="unidade.email" label="email" outlined required dense></v-text-field>
          </v-col>
        </v-row>
        <v-card>
          <v-tabs v-model="tabs" height="45">
            <v-tab :disabled="!unidade.id">
              <v-icon class="mr-2">
                mdi-settings
              </v-icon>
              Configurações
            </v-tab>
            <v-tab :disabled="!unidade.id">
              <v-icon class="mr-2">
                mdi-settings
              </v-icon>
              Textos
            </v-tab>
            <v-tab @click="loadMembros" :disabled="!unidade.id">
              <v-icon class="mr-2">
                mdi-account
              </v-icon>
              Colaborador
            </v-tab>
            <v-tab  @click="loadConselhos()" :disabled="!unidade.id">
              <v-icon class="mr-2">
                mdi-account-box-multiple
              </v-icon>
              Conselhos e Coms.
            </v-tab>
            <v-tab @click="loadMenus" :disabled="!unidade.id">
              <v-icon class="mr-2">
                mdi-menu
              </v-icon>
              Menus
            </v-tab>
            <v-tab @click="loadNoticiasVinculadas" :disabled="!unidade.id">
              <v-icon class="mr-2">
                mdi-new-box
              </v-icon>
              Notícias
            </v-tab>
            <v-tab @click="loadServicos" :disabled="!unidade.id">
              <v-icon class="mr-2">
                mdi-cog-box
              </v-icon>
              Serviços
            </v-tab>
            <v-tab>
              <v-icon class="mr-2">
                mdi-message-text-outline
              </v-icon>
              Competências
            </v-tab>
            <v-tab @click="loadDocs" :disabled="!unidade.id">
              <v-icon class="mr-2">
                mdi-paperclip
              </v-icon>
              Arquivos
            </v-tab>
            <v-tab @click="loadMidias" :disabled="!unidade.id">
              <v-icon class="mr-2">
                mdi-camera
              </v-icon>
              Midias
            </v-tab>
            <v-tab @click="loadPubConteudo()" :disabled="!unidade.id">
              <v-icon class="mr-2">
                mdi-eye
              </v-icon>
              Publicação
            </v-tab>
          </v-tabs>
          <v-divider></v-divider>
          <v-tabs-items v-model="tabs">
            <v-tab-item>
              <v-card flat>
                <v-row>
                  <v-col cols="12" md="2" v-if="unidade.id">
                    <v-checkbox v-model="unidade.comParent" label="Pode receber subpágina ?" color="success"
                      v-show="mode === 'save'">
                    </v-checkbox>
                  </v-col>
                  <v-col cols="12" md="2">
                    <v-checkbox v-model="unidade.link_externo" label="Página externa ?" color="success" hide-details
                      v-show="mode === 'save'">
                    </v-checkbox>
                  </v-col>
                  <v-col cols="12" md="2">
                    <v-checkbox v-model="unidade.menu" label="Possui menu ?" color="success" hide-details
                      v-show="mode === 'save'">
                    </v-checkbox>
                  </v-col>
                  <v-col cols="12" md="2">
                    <v-checkbox v-model="unidade.estrutura" label="Ver na estrutura ?" color="success" hide-details
                      v-show="mode === 'save'">
                    </v-checkbox>
                  </v-col>
                  <v-col cols="12" md="2">
                    <v-checkbox v-model="unidade.estatico" label="Página estatica?" color="success" hide-details
                      v-show="mode === 'save'">
                    </v-checkbox>
                  </v-col>
                  <v-col cols="12" md="2">
                    <v-checkbox v-model="unidade.organograma" label="Página do organograma ?" color="success" hide-details
                      v-show="mode === 'save'">
                    </v-checkbox>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="2">
                    <v-checkbox v-model="unidade.agenda" label="Posui agenda ?" color="success"
                      v-show="mode === 'save'">
                    </v-checkbox>
                  </v-col>
                  <v-col cols="12" md="2">
                    <v-checkbox v-model="unidade.noticias" label="Posui Notícia ?" color="success"
                      v-show="mode === 'save'">
                    </v-checkbox>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="5" lg="2">
                    <v-text-field v-model="unidade.icon" label="Ícone do serviço" outlined required dense
                      v-if="mode === 'save'">
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" md="5" lg="2">
                    <v-text-field v-model="unidade.color" label="Cor para o ícone e serviço" outlined required dense
                      v-if="mode === 'save'">
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" md="3" lg="2">
                    <v-text-field v-model="unidade.position" label="Posição do ícone na página" outlined required dense
                      hint="Exemplo: L ou D, padrão L">
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" md="3" lg="2">
                    <v-text-field v-model="unidade.posicao" label="Posição da página na lista" outlined required dense
                      hint="Exemplo: 1,ou 2,...">
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-text-field v-model="unidade.pagina" label="Caminho da pagina" outlined required dense hint="* obrigatório para paginas filho" persistent-hint></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="4">
                    <v-text-field v-model="unidade.link" label="Link interno ou Externo" outlined required dense
                      hint="Exemplo: interno /nome ou https://...">
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field v-model="unidade.ds_link" label="Descrição sobre o link ou nome do destino" outlined
                      required dense hint="Exemplo: Site de nota fical da prefeitura">
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" md="2">
                    <v-autocomplete v-model="unidade.target_url" :items="targets" required dense outlined
                      label="Target">
                    </v-autocomplete>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="8" lg="9">
                    <v-text-field v-model="unidade.url_imagem" label="Url da imagem" outlined required dense
                      v-if="mode === 'save'">
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" lg="3" md="4">
                    <v-card>
                      <v-img :src="unidade.url_imagem"></v-img>
                    </v-card>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="6">
                    <v-text-field v-model="unidade.sobre_atualizacao" label="Sobre a atualidade do portal" outlined required dense
                      v-if="mode === 'save'">
                    </v-text-field>
                  </v-col>
                </v-row>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-card flat>
                <v-card-subtitle>Editor de texto para unidade bloco (Sobre a página)</v-card-subtitle>
                <v-row>
                  <v-col cols="12"><v-card class="pa-2">
                      <ckeditor class="altura" :editor="editor" v-model="unidade.texto1" :config="editorConfig"
                        placeholder="Editor de texto para unidade bloco (Sobre a página)"></ckeditor>
                    </v-card>
                  </v-col>
                </v-row>
                <v-card-subtitle>Editor de texto para unidade bloco (Ouvidoria)</v-card-subtitle>
                <v-row>
                  <v-col cols="12"><v-card class="pa-2">
                      <ckeditor class="altura" :editor="editor" v-model="unidade.texto2" :config="editorConfig"
                        placeholder="Editor de texto para unidade bloco (Ouvidoria)"></ckeditor>
                    </v-card>
                  </v-col>
                </v-row>
                <v-card-subtitle>Editor de texto para unidade bloco 3</v-card-subtitle>
                <v-row>
                  <v-col cols="12"><v-card class="pa-2">
                      <ckeditor class="altura" :editor="editor" v-model="unidade.texto3" :config="editorConfig"
                        placeholder="Editor de texto para unidade bloco 3"></ckeditor>
                    </v-card>
                  </v-col>
                </v-row>
                <v-card-subtitle>Editor de texto para unidade bloco 4</v-card-subtitle>
                <v-row>
                  <v-col cols="12"><v-card class="pa-2">
                      <ckeditor class="altura" :editor="editor" v-model="unidade.texto4" :config="editorConfig"
                        placeholder="Editor de texto para unidade bloco 4"></ckeditor>
                    </v-card>
                  </v-col>
                </v-row>
                <v-card-subtitle>Editor de texto para unidade bloco 5</v-card-subtitle>
                <v-row>
                  <v-col cols="12"><v-card class="pa-2">
                      <ckeditor class="altura" :editor="editor" v-model="unidade.texto5" :config="editorConfig"
                        placeholder="Editor de texto para unidade bloco 5"></ckeditor>
                    </v-card>
                  </v-col>
                </v-row>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-card flat>
                <v-row justify="space-around">
                  <v-col cols="12" md="12">
                    <v-card>
                      <v-card-title>
                        Colaboradores
                      </v-card-title>
                      <v-data-table :headers="headersMembros" :items="membros">
                        <template v-slot:[`item.actions`]="{ item }">
                          <v-icon medium color="primary" class="mr-2" @click="loadMembro(item)">
                            mdi-square-edit-outline
                          </v-icon>
                          <v-icon medium color="error" class="mr-2" @click="loadMembro(item, 'remove')">
                            mdi-delete
                          </v-icon>
                        </template>
                      </v-data-table>
                      <v-row>
                        <v-col cols="12" md="6">
                          <v-btn color="success" class="ml-4 mb-2" v-if="unidade.id" @click="loadAddMembro">
                            <v-icon left>
                              mdi-plus
                            </v-icon>
                            Novo
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-col>
                </v-row>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-card flat>
                <v-row justify="space-around">
                  <v-col
                    cols="12"
                    md="12"
                  >
                    <v-card>
                      <v-data-table
                        :headers="headersConselhos"
                        :items="conselhos"
                      >
                        <template v-slot:[`item.actions`]="{ item }">
                          <v-icon
                            large
                            color="success"
                            class="mr-2"
                            @click="loadPageConselho(item)"
                          >
                            mdi-arrow-right-bold-box
                          </v-icon>
                        </template>
                      </v-data-table>
                      <v-row>
                        <v-col
                          cols="12"
                          md="6"
                        >
                          <v-btn
                            color="success"
                            class="ml-1 mb-3"
                            v-if="codigo"
                            @click="loadAddConselho"
                          >
                            <v-icon left>
                              mdi-content-save
                            </v-icon>
                            Add comissão
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-col>
                </v-row>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-card flat>
                <v-row justify="space-around">
                  <v-col cols="12" md="12">
                    <v-card>
                      <v-card-title>
                        Menus da unidade
                      </v-card-title>
                      <v-data-table :headers="headersMenu" :items="menuList">
                        <template v-slot:[`item.actions`]="{ item }">
                          <v-icon v-if="item.inativar === 1" medium color="primary" class="mr-2"
                            @click="loadActiveMenu(item)">
                            mdi-eye-off-outline
                          </v-icon>
                          <v-icon v-else medium color="primary" class="mr-2" @click="loadInactiveMenu(item)">
                            mdi-eye-outline
                          </v-icon>
                          <v-icon medium color="error" class="mr-2" @click="delMenu(item)">
                            mdi-delete
                          </v-icon>
                        </template>
                      </v-data-table>
                      <v-row>
                        <v-col cols="12" md="6">
                          <v-btn color="success" class="ml-4 mb-2" v-if="unidade.id" @click="loadAddMenu">
                            <v-icon left>
                              mdi-view-list
                            </v-icon>
                            Menu
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-col>
                </v-row>
              </v-card>
            </v-tab-item>
            <v-tab-item>
            <v-card flat>
              <v-container>
                <v-card>
                  <v-card-title>
                    Notícias vinculadas à unidades
                  </v-card-title>
                  <v-data-table
                    :headers="headersNoticiasVinculadas"
                    :items="noticiasVinculadas"
                  >
                    <template v-slot:[`item.actions`]="{ item }">
                      <v-icon
                        large
                        color="success"
                        class="mr-2"
                        @click="loadUpNoticia(item)"
                      >
                        mdi-square-edit-outline
                      </v-icon>
                      <v-icon
                        large
                        color="error"
                        class="mr-2"
                        @click="removeNoticia(item)">
                          mdi-delete
                      </v-icon>
                    </template>
                  </v-data-table>
                  <v-card-actions class="justify-end">
                    <v-btn
                      color="success"
                      class="ml-4 mb-2"
                      v-if="unidade.id"
                      @click="loadAddNoticia"
                    >
                      <v-icon left>
                        mdi-plus
                      </v-icon>
                      Add notícia
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-container>
            </v-card>
          </v-tab-item>
            <v-tab-item>
              <v-card flat>
                <v-row justify="space-around">
                  <v-col cols="12" md="12">
                    <v-card>
                      <v-card-title>
                        Serviços da unidade
                      </v-card-title>
                      <v-data-table :headers="headersServicos" :items="servicos">
                        <template v-slot:[`item.actions`]="{ item }">
                          <v-icon medium color="primary" class="mr-2" @click="loadServico(item)">
                            mdi-square-edit-outline
                          </v-icon>
                          <v-icon medium color="error" class="mr-2" @click="loadServico(item, 'remove')">
                            mdi-delete
                          </v-icon>
                        </template>
                      </v-data-table>
                      <v-row>
                        <v-col cols="12" md="6">
                          <v-btn color="success" class="ml-4 mb-2" v-if="unidade.id" @click="loadAddServico">
                            <v-icon left>
                              mdi-plus
                            </v-icon>
                            servicos
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-col>
                </v-row>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-card flat>
                <v-row>
                  <v-col cols="12" md="12">
                    <v-card class="pa-2">
                      <ckeditor class="altura" :editor="editor" v-model="unidade.texto" :config="editorConfig"
                        placeholder="Registro de Competências"></ckeditor>
                    </v-card>
                  </v-col>
                </v-row>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-card flat>
                <v-row justify="space-around">
                  <v-col cols="12" md="12">
                    <v-card>
                      <v-card-title>
                        Arquivos
                      </v-card-title>
                      <v-data-table :headers="headersDoc" :items="docs">
                        <template v-slot:[`item.actions`]="{ item }">
                          <v-icon medium color="primary" class="mr-2" @click="loadDoc(item)">
                            mdi-square-edit-outline
                          </v-icon>
                          <v-icon medium color="error" class="mr-2" @click="loadDoc(item, 'remove')">
                            mdi-delete
                          </v-icon>
                        </template>
                      </v-data-table>
                      <v-row>
                        <v-col cols="12" md="6">
                          <v-btn color="success" class="ml-4 mb-2" v-if="unidade.id" @click="loadAddDoc">
                            <v-icon left>
                              mdi-view-list
                            </v-icon>
                            Arquivos
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-col>
                </v-row>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-card flat>
                <v-row justify="space-around">
                  <v-col cols="12" md="12">
                    <v-card>
                      <v-card-title>
                        Fotos ou videos
                      </v-card-title>
                      <v-data-table :headers="headersMid" :items="midias" :search="search">
                        <template v-slot:[`item.actions`]="{ item }">
                          <v-icon medium color="primary" class="mr-2" @click="loadUrl(item)">
                            mdi-upload-network
                          </v-icon>
                          <v-icon medium color="primary" class="mr-2" @click="loadMid(item)">
                            mdi-square-edit-outline
                          </v-icon>
                          <v-icon medium color="error" class="mr-2" @click="loadMid(item, 'remove')">
                            mdi-delete
                          </v-icon>
                        </template>
                      </v-data-table>
                      <v-row>
                        <v-col cols="12" md="6">
                          <v-btn color="success" class="ml-4 mb-2" v-if="unidade.id" @click="loadAddMid">
                            <v-icon left>
                              mdi-camera
                            </v-icon>
                            Midias
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-col>
                </v-row>
              </v-card>
            </v-tab-item>
            <v-tab-item disabled></v-tab-item>
          </v-tabs-items>
        </v-card>
        <v-row class="mt-4">
          <v-col cols="12" md="10">
            <v-btn :disabled="!valid" color="success" class="mr-4" v-if="mode === 'save'" @click="save">
              <v-icon left>
                mdi-content-save
              </v-icon>
              Salvar
            </v-btn>
            <v-btn color="error" class="mr-4" v-if="mode === 'remove'" @click="remove">
              <v-icon left>
                mdi-content-save
              </v-icon>
              Deletar
            </v-btn>
            <v-btn color="secondary" class="mr-4" @click="reset">
              <v-icon left>
                mdi-broom
              </v-icon>
              Limpar
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
      <v-row justify="space-around">
        <v-col cols="auto">
          <v-dialog v-model="dialog" transition="dialog-bottom-transition" fullscreen>
            <template v-slot:default="dialog">
              <v-card>
                <v-toolbar color="primary" dark>
                  Pesquisar páginas
                </v-toolbar>
                <v-card-title>
                  <v-text-field class="search" v-model="search" append-icon="mdi-magnify" label="Pesquisar" single-line
                    hide-details>
                  </v-text-field>
                </v-card-title>
                <v-data-table :headers="headers" :items="unidades" :search="search">
                  <template v-slot:[`item.actions`]="{ item }">
                    <v-icon medium color="primary" class="mr-2" @click="loadUnidade(item)">
                      mdi-square-edit-outline
                    </v-icon>
                    <v-icon medium color="error" class="mr-2" @click="loadUnidade(item, 'remove')">
                      mdi-delete
                    </v-icon>
                  </template>
                </v-data-table>
                <v-card-actions class="justify-end">
                  <v-btn color="error" @click="dialog.value = false">Fechar</v-btn>
                </v-card-actions>
              </v-card>
            </template>
          </v-dialog>
        </v-col>
      </v-row>
      <v-container>
        <v-dialog v-model="dialogNoticias" transition="dialog-bottom-transition" fullscreen>
          <v-card>
            <v-toolbar color="primary" dark>
              Pesquisar Notícias
            </v-toolbar>
            <v-card-title>
              <v-text-field
                class="search"
                v-model="search"
                append-icon="mdi-magnify"
                label="Pesquisar"
                single-line
                hide-details>
              </v-text-field>
            </v-card-title>
            <v-data-table
              :headers="headersNoticias"
              :items="noticias"
              :search="search">
                <template v-slot:[`item.actions`]="{ item }">
                  <v-icon
                    medium
                    color="primary"
                    class="mr-2"
                    @click="loadNoticia(item)">
                      mdi-square-edit-outline
                  </v-icon>
                </template>
            </v-data-table>
            <v-card-actions class="justify-end">
              <v-btn
                color="error"
                @click="closeNoticiasFilter()"
              >
                Fechar pesquisa
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-container>
      <v-container>
        <v-dialog v-model="addDoc" transition="dialog-top-transition">
          <template v-slot:default="dialog">
            <v-card>
              <v-toolbar color="primary" dark>
                Adicionar arquivos anexo
              </v-toolbar>
              <v-card elevation="2" class="pa-3">
                <div class="ma-5">
                  <PageTitle main="" icon="mdi-pencil-box-outline" sub="Documento em anexo da página" home="" />
                  <v-form>
                    <input id="user-id" type="hidden" v-model="doc.usuario" />
                    <input id="doc-id" type="hidden" v-model="doc.id" />
                    <input id="doc-uuid" type="hidden" v-model="doc.uid_unidade" />
                    <input id="uid_boletim" type="hidden" v-model="doc.uuid_unidade" />
                    <v-row>
                      <v-col cols="12" md="2">
                        <v-text-field v-model="unidade.id" label="Código" dense filled>
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" md="3" v-if="unidade.id">
                        <v-checkbox v-model="doc.inativar" label="Inativar arquivo?" color="success" class="mt-0 mb-2"
                          v-show="mode === 'save'"></v-checkbox>
                      </v-col>
                      <v-col cols="12" md="3" v-if="unidade.id">
                        <v-text-field v-model="doc.ano" label="Ano de referência" color="success" class="mt-0 mb-2"
                          v-show="mode === 'save'"></v-text-field>
                      </v-col>
                      <v-col cols="12" md="3">
                        <v-menu v-model="menu6" :close-on-content-click="false" :nudge-right="40"
                          transition="scale-transition" offset-y min-width="auto">
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field v-mask="datanex" v-model="data_anex" label="Data de publicacao.:" dense
                              outlined @blur="mudaDataG">
                              <v-icon slot="append" color="success" large v-bind="attrs" v-on="on">
                                mdi-calendar
                              </v-icon>
                            </v-text-field>
                          </template>
                          <v-date-picker locale="pt-br" v-model="date6" @input="dateG">
                          </v-date-picker>
                        </v-menu>
                      </v-col>
                    </v-row>
                    <v-row>
                      <input accept="application/vnd.ms-excel, application/vnd.ms-word, application/pdf"
                        prepend-icon="mdi-paperclip" label="Documento" v-if="uploadReady" type="file" ref="file"
                        @change="selectFile()">
                    </v-row>
                  </v-form>
                </div>
                <v-card-actions class="justify-end">
                  <v-btn color="success" class="mr-4" v-if="unidade.id" type="submit" @click.prevent="docUpload()">
                    <v-icon left>
                      mdi-content-save
                    </v-icon>
                    Salvar
                  </v-btn>
                  <v-btn color="error" class="mr-4" v-if="unidade.id" @click="clearUpload">
                    Remover
                    <v-icon left>
                      mdi-broom
                    </v-icon>
                  </v-btn>
                  <v-btn color="danger" class="mr-4" @click="dialog.value = false">
                    Sair
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-card>
          </template>
        </v-dialog>
      </v-container>
      <!-- Dialog de adicionar categorias para unidades-->
      <v-container>
        <v-dialog v-model="dialogAddCategoria" transition="dialog-top-transition">
          <v-card>
            <v-toolbar color="primary" dark>
              Categorias
            </v-toolbar>
            <v-card elevation="2" class="pa-3">
              <div class="ma-5">
                <PageTitle icon="mdi-pencil-box-outline" sub="Categorias de unidade" main='' home='' />
                <form-cat :categoria="categoria" :mode="mode" />
              </div>
              <v-card-actions class="justify-end">
                <v-btn color="success" class="mr-4" type="submit" @click.prevent="saveCat()">
                  <v-icon left>
                    mdi-content-save
                  </v-icon>
                  Salvar
                </v-btn>
                <v-btn color="danger" class="mr-4" @click="closeDialogCategorias">
                  Sair
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-card>
        </v-dialog>
      </v-container>
      <!-- Dialog de adicionar subcategoria de unidades -->
      <v-container>
        <v-dialog v-model="dialogAddSubCategoria" transition="dialog-top-transition">
          <v-card>
            <v-toolbar color="primary" dark>
              Subcategorias
            </v-toolbar>
            <v-card elevation="2" class="pa-3">
              <div class="ma-5">
                <PageTitle icon="mdi-pencil-box-outline" sub="Subcategorias de categorias de unidades" main=''
                  home='' />
                <form-sub-cat :subcategoria="subcategoria" :mode="mode" />
              </div>
              <v-card-actions class="justify-end">
                <v-btn color="success" class="mr-4" type="submit" @click.prevent="saveSubCat()">
                  <v-icon left>
                    mdi-content-save
                  </v-icon>
                  Salvar
                </v-btn>
                <v-btn color="danger" class="mr-4" @click="closeDialogCategorias">
                  Sair
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-card>
        </v-dialog>
      </v-container>
      <!-- Dialog cadastro de cargos e funções -->
      <v-container>
        <v-dialog v-model="dialogCargo" transition="dialog-top-transition">
          <v-card tile>
            <v-toolbar color="primary" dark class="mb-2">
              <v-icon large>
                mdi-pencil-box-outline
              </v-icon>
              Adicionar cargos e funções
            </v-toolbar>
            <v-form ref="form">
              <Cargos />
            </v-form>
            <v-card-actions class="justify-end">
              <v-btn color="primary" class="mr-4" @click="closeDialog">
                <v-icon left class="mr-3">mdi-close</v-icon>
                Sair
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-container>
      <v-container>
        <v-dialog v-model="addMidia" transition="dialog-top-transition">
          <template v-slot:default="dialog">
            <v-card>
              <v-toolbar color="primary" dark>
                Adicionar Imagens ou videos
              </v-toolbar>
              <v-card elevation="2" class="pa-3">
                <div class="ma-5">
                  <PageTitle main="" icon="mdi-pencil-box-outline" sub="Imagens ou videos da página" home="" />
                  <v-form>
                    <input id="user-id" type="hidden" v-model="midia.usuario" />
                    <input id="doc-id" type="hidden" v-model="midia.id" />
                    <input id="midia-uuid" type="hidden" v-model="midia.uid_unidade" />
                    <input id="uid_boletim" type="hidden" v-model="midia.uuid_unidade" />
                    <v-row>
                      <v-col cols="12" md="2">
                        <v-text-field v-model="unidade.id" label="Código" dense filled>
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" md="3" v-if="midia.id">
                        <v-checkbox v-model="midia.inativar" label="Inativar mídia?" color="success" class="mt-0 mb-2"
                          v-show="mode === 'save'"></v-checkbox>
                      </v-col>
                      <v-col cols="12" md="3">
                        <v-menu v-model="menu2" :close-on-content-click="false" :nudge-right="40"
                          transition="scale-transition" offset-y min-width="auto">
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field v-mask="datamid" v-model="data_mid" label="Data de publicacao.:" dense
                              outlined @blur="mudaDataA">
                              <v-icon slot="append" color="success" large v-bind="attrs" v-on="on">
                                mdi-calendar
                              </v-icon>
                            </v-text-field>
                          </template>
                          <v-date-picker locale="pt-br" v-model="date2" @input="dateA">
                          </v-date-picker>
                        </v-menu>
                      </v-col>
                    </v-row>
                    <v-row>
                      <input accept="image/png, image/jpg, image/jpeg, image/bmp" prepend-icon="mdi-camera"
                        label="Arquivo de imagem ou video" v-if="uploadReady" type="file" ref="file"
                        @change="selectFile()">
                    </v-row>
                  </v-form>
                </div>
                <v-card-actions class="justify-end">
                  <v-btn color="success" class="mr-4" v-if="unidade.id" type="submit" @click.prevent="fileUpload()">
                    <v-icon left>
                      mdi-content-save
                    </v-icon>
                    Salvar
                  </v-btn>
                  <v-btn color="error" class="mr-4" v-if="unidade.id" @click="clearUpload">
                    Remover
                    <v-icon left>
                      mdi-broom
                    </v-icon>
                  </v-btn>
                  <v-btn color="danger" class="mr-4" @click="dialog.value = false">
                    Sair
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-card>
          </template>
        </v-dialog>
      </v-container>
      <!-- Módulo de menus da página-->
      <v-container>
        <v-dialog v-model="addMenus" transition="dialog-top-transition">
          <v-card>
            <v-toolbar color="primary" dark>
              Menus da unidadde
            </v-toolbar>
            <v-card elevation="2" class="pa-3">
              <div class="ma-5">
                <PageTitle icon="mdi-pencil-box-outline" sub="Menus da unidade" />
                <v-form>
                  <input id="user-id" type="hidden" v-model="menuunidade.usuario" />
                  <input id="uid_unidade" type="hidden" v-model="menuunidade.uid_unidade" />
                  <input id="id_menu" type="hidden" v-model="menuunidade.id" />
                  <v-row>
                    <v-col cols="12" md="2">
                      <v-text-field v-model="codeMenu" label="Código" dense outlined>
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" md="3" v-if="codeMenu.id">
                      <v-checkbox v-model="menuunidade.inativar" label="Inativar menu ?" color="success"
                        class="mt-0 mb-2"></v-checkbox>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="3">
                      <v-autocomplete v-model="gruponome" :items="grupoMenu" label="Grupo de menus" clearable outlined
                        dense @change="loadSubMenuSite()"></v-autocomplete>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-autocomplete v-model="menunome" :items="subMenu" label="Subgrupo do menu" clearable outlined
                        dense @change="loadMenuSite()"></v-autocomplete>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-autocomplete v-model="menuunidade.uid_menu" :items="parentMenu" label="Nome" clearable outlined
                        dense @change="loadMenuAdd()"></v-autocomplete>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="3">
                      <v-text-field v-model="menuunidade.chave" label="Chave" outlined required dense></v-text-field>
                    </v-col>
                    <v-col cols="12" md="7">
                      <v-text-field v-model="menuunidade.menu" label="Menu" outlined required dense></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="10">
                      <v-text-field v-model="menuunidade.ds_menu" label="Descrição" outlined required
                        dense></v-text-field>
                    </v-col>
                  </v-row>
                </v-form>
              </div>
              <v-card-actions class="justify-end">
                <v-btn color="success" class="mr-4" v-if="unidade.id" type="submit" @click="addSairMenu">
                  <v-icon left>
                    mdi-content-save
                  </v-icon>
                  Salvar e sair
                </v-btn>
                <v-btn color="success" class="mr-4" v-if="unidade.id" type="submit" @click="addContMenu">
                  <v-icon left>
                    mdi-content-save
                  </v-icon>
                  Salvar e continuar
                </v-btn>
                <v-btn color="error" class="mr-4" v-if="unidade.id" @click="resetMenu">
                  Limpar
                  <v-icon left>
                    mdi-broom
                  </v-icon>
                </v-btn>
                <v-btn color="danger" class="mr-4" @click="closeDialogMenu()">
                  Sair
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-card>
        </v-dialog>
      </v-container>
      <v-container>
        <v-dialog v-model="addMembro" transition="dialog-top-transition">
          <template v-slot:default="dialog">
            <v-card>
              <v-toolbar color="primary" dark>
                Adicionar membros
              </v-toolbar>
              <v-card elevation="2" class="pa-3">
                <div class="ma-5">
                  <PageTitle icon="mdi-pencil-box-outline" sub="Membros da página 2" />
                  <v-form>
                    <input id="link-id" type="hidden" v-model="membro.id" />
                    <input id="user-id" type="hidden" v-model="membro.usuario" />
                    <input id="user-id" type="hidden" v-model="membro.uid_agente" />
                    <input id="user-id" type="hidden" v-model="membro.uid_unidade" />
                    <v-row>
                      <v-col cols="12" md="2">
                        <v-text-field v-model="unidade.id" label="Código" dense filled>
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" md="3" v-if="membro.id">
                        <v-checkbox v-model="membro.inativar" label="Inativar membro ?" color="success"
                          class="mt-0 mb-2" v-show="mode === 'save'"></v-checkbox>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <span><strong>Agente público..:</strong>{{ pessoa.agente }}</span>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" md="3" lg="3" class="mr-0 pr-0">
                        <v-text-field class="codigo mr-0" v-model="membro.uid_agente" label="Código..." dense outlined
                          flat @change="loadPedidoPessoaId()" :disabled="membro.id">
                          <v-btn class="btn-outer pa-0" slot="append" color="success" tile @click="loadFtPessoa">
                            <v-icon class="mx-0" color="white">
                              mdi-magnify
                            </v-icon>
                          </v-btn>
                          <v-btn class="btn-outer-right pa-0" slot="append" color="light" tile @click="loadAddPessoa">
                            <v-icon class="mx-0" color="black">
                              mdi-plus
                            </v-icon>
                          </v-btn>
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" md="7" lg="5" class="mx-0 px-0">
                        <v-text-field class="v-busca-nome ml-0" v-model="membro.agente" :loading="loading"
                          aria-autocomplete="none" :search-input.sync="search" label="Nome" outlined dense
                          @keyup.native="loadSeach()" :disabled="membro.id">
                          <v-icon v-if="membro.agente" slot="append" color="black" @click.prevent="clPessoa">
                            mdi-close
                          </v-icon>
                        </v-text-field>
                        <v-card v-show="listar === 'sim'" class="my-0 py-0">
                          <ul class="filtro">
                            <li v-for="item in items" :key="item.id">
                              <a @click="loadPedidoPessoaId(item, 'novo')"> {{ item.agente }}</a>
                            </li>
                          </ul>
                        </v-card>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" md="4" lg="3" class="mr-0 pr-0">
                        <v-autocomplete v-model="membro.uid_cargo" :items="cargos" required dense outlined
                          label="Cargo ou função">
                          <v-btn class="btn-outer pa-0" slot="append" color="success" tile @click="loadFtCargo">
                            <v-icon class="mx-0" color="white">
                              mdi-magnify
                            </v-icon>
                          </v-btn>
                          <v-btn class="btn-outer-right pa-0" slot="append" color="light" tile @click="loadAddCargo">
                            <v-icon class="mx-0" color="black">
                              mdi-plus
                            </v-icon>
                          </v-btn>
                        </v-autocomplete>
                      </v-col>
                      <v-col cols="12" md="5">
                        <v-autocomplete v-model="membro.uid_gestao" :items="gestoes" required dense outlined
                          label="Gestão">
                        </v-autocomplete>
                      </v-col>
                    </v-row>
                  </v-form>
                </div>
                <v-card-actions class="justify-end">
                  <v-btn color="success" class="mr-4" v-if="membro.id" type="submit" @click="addMembroSair">
                    <v-icon left>
                      mdi-content-save
                    </v-icon>
                    Atualizar sair
                  </v-btn>
                  <v-btn color="success" class="mr-4" v-if="!membro.id" type="submit" @click="addMembroSair">
                    <v-icon left>
                      mdi-content-save
                    </v-icon>
                    Salvar e sair
                  </v-btn>
                  <v-btn color="success" class="mr-4" v-if="!membro.id" type="submit" @click="addMembroCont">
                    <v-icon left>
                      mdi-content-save
                    </v-icon>
                    Salvar e continuar
                  </v-btn>
                  <v-btn color="error" class="mr-4" v-if="!membro.id" @click="resetMembro">
                    Limpar
                    <v-icon left>
                      mdi-broom
                    </v-icon>
                  </v-btn>
                  <v-btn color="danger" class="mr-4" @click="dialog.value = false">
                    Sair
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-card>
          </template>
        </v-dialog>
      </v-container>
      <!-- Conselhos e comissões -->
      <v-container>
        <v-dialog
          v-model="DialogConselho"
          transition="dialog-bottom-transition"
        >
          <v-card
            class="py-4 px-2 auth-content"
            tile
          >
            <PageTitle
              icon="mdi-pencil-box-outline"
              sub="Conselhos e Comissões"
            />
            <input
              id="user-id"
              type="hidden"
              v-model="conselho.usuario"
            />
            <input
              id="comissao-id"
              type="hidden"
              v-model="conselho.id"
            />
            <input
              id="comissao-uuid"
              type="hidden"
              v-model="conselho.uuid"
            />
            <input
              id="comissao-uuid"
              type="hidden"
              v-model="conselho.uid_mandato"
            />
            <v-row>
              <v-col
                cols="12"
                md="2"
              >
                <v-text-field
                  v-model="cdComissao"
                  label="Código"
                  dense
                  outlined
                >
                </v-text-field>
              </v-col>
              <v-col
                cols="12"
                md="3"
                lg="2"
              >
                <v-menu
                  v-model="menu4"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-mask="datapub"
                      v-model="data_cad"
                      label="Data de cadastro.:"
                      dense
                      outlined
                      @blur="mudaDataE"
                    >
                      <v-icon
                        slot="append"
                        color="success"
                        large
                        v-bind="attrs"
                        v-on="on"
                      >
                        mdi-calendar
                      </v-icon>
                    </v-text-field>
                  </template>
                  <v-date-picker
                    locale="pt-br"
                    v-model="date4"
                    @input="dateE"
                  >
                  </v-date-picker>
                </v-menu>
              </v-col>
              <v-col
                cols="12"
                md="2"
                lg="2"
              >
                <v-text-field
                  v-model="conselho.ano_inicio"
                  label="Ano inicial.:"
                  dense
                  outlined
                >
                </v-text-field>
              </v-col>
              <v-col
                cols="12"
                md="2"
                lg="2"
              >
                <v-text-field
                  v-model="conselho.ano_termino"
                  label="Ano final.:"
                  dense
                  outlined
                >
                </v-text-field>
              </v-col>
              <v-col
                cols="12"
                md="3"
                v-if="codigo"
              >
                <v-checkbox
                  v-model="conselho.inativar"
                  label="Inativar comissão?"
                  color="success"
                ></v-checkbox>
              </v-col>
            </v-row>
            <v-row>
              <v-col
                cols="12"
                md="3"
                lg="2"
              >
                <v-text-field
                  v-model="conselho.nome"
                  label="Nome"
                  dense
                  outlined
                  hint="Exemplo: CJR, caixa alta"
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                md="4"
                lg="3"
              >
                <v-autocomplete
                  clearable
                  dense
                  outlined
                  label="Biênio"
                  v-model="conselho.uid_bienio"
                  :items="bienios"
                ></v-autocomplete>
              </v-col>
            </v-row>
            <v-row>
              <v-col
                cols="12"
                md="9"
                lg="10"
              >
                <v-text-field
                  v-model="conselho.titulo"
                  label="Título"
                  dense
                  outlined
                ></v-text-field>
              </v-col>
            </v-row>
            <v-card-actions class="justify-end">
              <v-btn
                color="success"
                class="ml-1 mr-4"
                v-if="!conselho.id"
                @click="addConselhoSair"
              >
                <v-icon left>
                  mdi-content-save
                </v-icon>
                Adicionar e sair
              </v-btn>
              <v-btn
                color="success"
                class="ml-1 mr-4"
                v-if="codigo"
                @click="addConselhoCont"
              >
                <v-icon left>
                  mdi-content-save
                </v-icon>
                Adicionar e continuar
              </v-btn>
              <v-btn
                color="error"
                @click="closeDialogConselho()"
              >Fechar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-container>
      <v-container>
        <v-dialog v-model="dialodAddServico" transition="dialog-top-transition">
          <template v-slot:default>
            <v-card>
              <v-toolbar color="primary" dark>
                Adicionar servicos
              </v-toolbar>
              <v-card elevation="2" class="pa-3">
                <div class="ma-5">
                  <PageTitle icon="mdi-pencil-box-outline" sub="servicos da página" />
                  <v-form>
                    <input id="servico-id" type="hidden" v-model="servico.id" />
                    <input id="user-id" type="hidden" v-model="servico.usuario" />
                    <input id="uid_page" type="hidden" v-model="servico.uid_unidade" />
                    <v-row>
                      <v-col cols="12" md="2">
                        <v-text-field v-model="unidade.id" label="Código" dense filled>
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" md="3" v-if="servico.id">
                        <v-checkbox v-model="servico.inativar" label="Inativar Serviço ?" color="success"
                          class="mt-0 mb-2"></v-checkbox>
                      </v-col>
                      <v-col cols="12" md="3">
                        <v-checkbox v-model="servico.link_externo" label="Link externo ?" color="success"
                          class="mt-0 mb-2"></v-checkbox>
                      </v-col>
                      <v-col cols="12" md="2">
                        <v-text-field v-model="servico.ano" label="Ano ref." dense outlined>
                        </v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" md="5">
                        <v-autocomplete v-model="servico.uid_categoria" :items="categorias" required dense outlined
                          label="Categoria" @change="loadSubCategorias(cat = servico.uid_categoria)">
                        </v-autocomplete>
                      </v-col>
                      <v-col cols="12" md="5">
                        <v-autocomplete v-model="servico.uid_subcategoria" :items="subcategorias" required dense
                          outlined label="Subcategoria" @change="loadAdmCampos(id = servico.uid_subcategoria)"
                          :disabled="!servico.uid_categoria">
                        </v-autocomplete>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" md="10">
                        <v-text-field v-model="servico.titulo" label="Título" outlined required dense></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row v-if="Galuno">
                      <v-col cols="12" md="5">
                        <v-text-field v-model="servico.nome" label="Nome da criança" outlined required
                          dense></v-text-field>
                      </v-col>
                      <v-col cols="12" md="5">
                        <v-text-field v-model="servico.responsavel" label="Responsável pela criança" outlined required
                          dense></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" md="10">
                        <v-text-field v-model="servico.justificativa" label="Justificativa" outlined required
                          dense></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col v-if="Galuno" cols="12" md="2">
                        <v-autocomplete v-model="servico.turma" :items="turmas" required dense outlined label="Turma">
                        </v-autocomplete>
                      </v-col>
                      <v-col v-if="Gadm" cols="12" md="2">
                        <v-text-field v-model="servico.total" label="Nº total de Vagas" dense outlined>
                        </v-text-field>
                      </v-col>
                      <v-col v-if="Gadm" cols="12" md="2">
                        <v-text-field v-model="servico.v_bercario" label="Vagas berçário" dense outlined>
                        </v-text-field>
                      </v-col>
                      <v-col v-if="Gadm" cols="12" md="2">
                        <v-text-field v-model="servico.v_maternal1" label="Vagas maternal I" dense outlined>
                        </v-text-field>
                      </v-col>
                      <v-col v-if="Gadm" cols="12" md="2">
                        <v-text-field v-model="servico.v_maternal2" label="Vagas maternal II" dense outlined>
                        </v-text-field>
                      </v-col>
                      <v-col v-if="Gadm" cols="12" md="2">
                        <v-checkbox v-model="servico.espera" label="Possui espera ?" color="success"
                          class="mt-0 mb-2"></v-checkbox>
                      </v-col>
                    </v-row>
                    <!-- Sessão para movimentações de alunos, vagas e afins-->
                    <v-card>
                      <v-tabs v-model="tabs2" height="45">
                        <v-tab @click="loadVagas()"
                        >
                          <v-icon class="mr-2">
                            mdi-settings
                          </v-icon>
                          Vagas
                        </v-tab>
                        <v-tab @click="loadAlunos()">
                          <v-icon class="mr-2">
                            mdi-settings
                          </v-icon>
                          Matriculas
                        </v-tab>
                      </v-tabs>
                      <v-divider></v-divider>
                      <v-tabs-items v-model="tabs2">
                        <v-tab-item>
                          <v-card flat>
                              <v-card-title>
                                Gestão de vagas
                              </v-card-title>
                              <v-data-table :headers="headersVaga" :items="vagas">
                                <template v-slot:[`item.actions`]="{ item }">
                                  <v-icon medium color="primary" class="mr-2" @click="loadVaga(item)">
                                    mdi-square-edit-outline
                                  </v-icon>
                                  <v-icon medium color="error" class="mr-2" @click="loadVaga(item, 'remove')">
                                    mdi-delete
                                  </v-icon>
                                </template>
                              </v-data-table>
                              <v-row>
                                <v-col cols="12" md="6">
                                  <v-btn color="success" class="ml-4 mb-2" v-if="servico.id" @click="loadAddVaga">
                                    <v-icon left>
                                      mdi-view-list
                                    </v-icon>
                                    Vagas
                                  </v-btn>
                                </v-col>
                              </v-row>
                          </v-card>
                        </v-tab-item>
                        <v-tab-item>
                          <v-card flat>
                            <v-card-title>
                                Gestão do aluno
                              </v-card-title>
                              <v-data-table :headers="headersAluno" :items="alunos">
                                <template v-slot:[`item.actions`]="{ item }">
                                  <v-icon medium color="primary" class="mr-2" @click="loadAluno(item)">
                                    mdi-square-edit-outline
                                  </v-icon>
                                  <v-icon medium color="error" class="mr-2" @click="loadAluno(item, 'remove')">
                                    mdi-delete
                                  </v-icon>
                                </template>
                              </v-data-table>
                              <v-row>
                                <v-col cols="12" md="6">
                                  <v-btn color="success" class="ml-4 mb-2" v-if="servico.id" @click="loadAddAluno">
                                    <v-icon left>
                                      mdi-view-list
                                    </v-icon>
                                    Alunos
                                  </v-btn>
                                </v-col>
                              </v-row>
                          </v-card>
                        </v-tab-item>
                      </v-tabs-items>
                    </v-card>
                    <v-row>
                      <v-col v-if="Gadm" cols="12" md="2">
                        <v-text-field v-model="servico.deferido" label="Deferidos" dense outlined>
                        </v-text-field>
                      </v-col>
                      <v-col v-if="Gadm" cols="12" md="2">
                        <v-text-field v-model="servico.indeferido" label="Indeferidos" dense outlined>
                        </v-text-field>
                      </v-col>
                      <v-col v-if="Gadm" cols="12" md="2">
                        <v-text-field v-model="servico.remanejado" label="Remanejado" dense outlined>
                        </v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" md="8">
                        <v-text-field v-model="servico.link" label="Link de destino" outlined required dense
                          v-if="mode === 'save'"></v-text-field>
                      </v-col>
                      <v-col cols="12" md="2">
                        <v-autocomplete v-model="servico.target" :items="targets" required dense outlined label="Target"
                          :disabled="!servico.link_externo">
                        </v-autocomplete>
                      </v-col>
                    </v-row>
                    <v-card flat>
                      <v-row>
                        <v-col cols="12" md="12">
                          <v-card class="pa-2">
                            <ckeditor class="altura" :editor="editor" v-model="servico.html" :config="editorConfig"
                              placeholder="Observações adicionais"></ckeditor>
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-form>
                </div>
                <v-card-actions class="justify-end">
                  <v-btn color="success" class="mr-4" v-if="servico.id" type="submit" @click="addServicoSair">
                    <v-icon left>
                      mdi-content-save
                    </v-icon>
                    Atualizar
                  </v-btn>
                  <v-btn color="success" class="mr-4" v-if="!servico.id" type="submit" @click="addServicoSair">
                    <v-icon left>
                      mdi-content-save
                    </v-icon>
                    Salvar e sair
                  </v-btn>
                  <v-btn color="success" class="mr-4" v-if="!servico.id" type="submit" @click="addServicoCont">
                    <v-icon left>
                      mdi-content-save
                    </v-icon>
                    Salvar e continuar
                  </v-btn>
                  <v-btn color="error" class="mr-4" v-if="!servico.id" @click="resetServico">
                    Limpar
                    <v-icon left>
                      mdi-broom
                    </v-icon>
                  </v-btn>
                  <v-btn color="danger" class="mr-4" @click="closeServico()">
                    Sair
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-card>
          </template>
        </v-dialog>
      </v-container>
      <v-container>
        <v-dialog v-model="addVagas" transition="dialog-top-transition">
          <template v-slot:default="dialog">
            <v-card>
              <v-toolbar color="primary" dark>
                Adicionar Vagas por turma
              </v-toolbar>
              <v-card elevation="2" class="pa-3">
                <div class="ma-5">
                  <PageTitle icon="mdi-pencil-box-outline" sub="Vagas do ano letivo" />
                  <v-form>
                    <input id="vaga-id" type="hidden" v-model="vaga.id" />
                    <input id="user-id" type="hidden" v-model="vaga.usuario" />
                    <input id="uid_servico" type="hidden" v-model="vaga.uid_servico" />
                    <v-row>
                      <v-col cols="12" md="2">
                        <v-text-field v-model="vaga.id" label="Código" dense filled>
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" md="3" v-if="vaga.id">
                        <v-checkbox v-model="vaga.inativar" label="Inativar vaga ?" color="success"
                          class="mt-0 mb-2"></v-checkbox>
                      </v-col>
                      <v-col cols="12" md="2">
                        <v-text-field v-model="servico.ano" label="Ano ref." dense outlined>
                        </v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" md="2">
                        <v-autocomplete v-model="vaga.uid_turma" :items="turmas" required dense outlined label="Turma">
                        </v-autocomplete>
                      </v-col>
                      <v-col cols="12" md="2">
                        <v-text-field v-model="vaga.qt_vaga" label="Total de Vagas" dense outlined>
                        </v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col v-if="Gadm" cols="12" md="2">
                        <v-text-field v-model="vaga.ds_vaga" label="Observações adicionais" dense outlined>
                        </v-text-field>
                      </v-col>
                    </v-row>
                  </v-form>
                </div>
                <v-card-actions class="justify-end">
                  <v-btn color="success" class="mr-4" v-if="vaga.id" type="submit" @click="addVagaSair">
                    <v-icon left>
                      mdi-content-save
                    </v-icon>
                    Atualizar
                  </v-btn>
                  <v-btn color="success" class="mr-4" v-if="!vaga.id" type="submit" @click="addVagaSair">
                    <v-icon left>
                      mdi-content-save
                    </v-icon>
                    Salvar e sair
                  </v-btn>
                  <v-btn color="success" class="mr-4" v-if="!vaga.id" type="submit" @click="addVagaCont">
                    <v-icon left>
                      mdi-content-save
                    </v-icon>
                    Salvar e continuar
                  </v-btn>
                  <v-btn color="error" class="mr-4" v-if="!vaga.id" @click="resetVaga">
                    Limpar
                    <v-icon left>
                      mdi-broom
                    </v-icon>
                  </v-btn>
                  <v-btn color="danger" class="mr-4" @click="dialog.value = false">
                    Sair
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-card>
          </template>
        </v-dialog>
      </v-container>
      <v-container>
        <v-dialog v-model="dialogAddAluno" transition="dialog-top-transition">
          <template v-slot:default>
            <v-card>
              <v-toolbar color="primary" dark>
                Gestão dos alunos
              </v-toolbar>
              <v-card elevation="2" class="pa-3">
                <div class="ma-5">
                  <PageTitle icon="mdi-pencil-box-outline" sub="Adicionar ou editar alunos" />
                  <v-form>
                    <input id="aluno-id" type="hidden" v-model="aluno.id" />
                    <input id="user-id" type="hidden" v-model="aluno.usuario" />
                    <input id="uid_unidade" type="hidden" v-model="aluno.uid_unidade" />
                    <v-row>
                      <v-col cols="12" md="2">
                        <v-text-field v-model="aluno.id" label="Código" dense filled>
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" md="3" v-if="aluno.id">
                        <v-checkbox v-model="aluno.inativar" label="Inativar Aluno ?" color="success"
                          class="mt-0 mb-2"></v-checkbox>
                      </v-col>
                      <v-col cols="12" md="3" v-if="aluno.id">
                        <v-checkbox v-model="aluno.matriculado" label="Aluno matriculado ?" color="success"
                          class="mt-0 mb-2"></v-checkbox>
                      </v-col>
                      <v-col cols="12" md="2">
                        <v-text-field v-model="servico.ano" label="Ano ref." dense outlined>
                        </v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" md="2">
                        <v-autocomplete v-model="aluno.uid_turma" :items="turmas" required dense outlined label="Turma">
                        </v-autocomplete>
                      </v-col>
                      <v-col cols="12" md="2">
                        <v-text-field v-model="aluno.ano_letivo" label="Ano letivo" dense outlined>
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" md="2">
                        <v-menu v-model="menu3" :close-on-content-click="false" :nudge-right="40"
                          transition="scale-transition" offset-y min-width="auto">
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field v-mask="datapub" v-model="data_nasc" label="Data de nascimento.:" dense
                              outlined @blur="mudaDataB">
                              <v-icon slot="append" color="success" large v-bind="attrs" v-on="on">
                                mdi-calendar
                              </v-icon>
                            </v-text-field>
                          </template>
                          <v-date-picker locale="pt-br" v-model="date3" @input="dateB">
                          </v-date-picker>
                        </v-menu>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" md="4">
                        <v-text-field v-model="aluno.aluno" label="Aluno" dense outlined>
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" md="6">
                        <v-text-field v-model="aluno.n_mae" label="Mãe" dense outlined>
                        </v-text-field>
                      </v-col>
                    </v-row>
                  </v-form>
                </div>
                <v-card-actions class="justify-end">
                  <v-btn color="success" class="mr-4" v-if="aluno.id" type="submit" @click="addAlunoSair">
                    <v-icon left>
                      mdi-content-save
                    </v-icon>
                    Atualizar
                  </v-btn>
                  <v-btn color="success" class="mr-4" v-if="!aluno.id" type="submit" @click="addAlunoSair">
                    <v-icon left>
                      mdi-content-save
                    </v-icon>
                    Salvar e sair
                  </v-btn>
                  <v-btn color="success" class="mr-4" v-if="!aluno.id" type="submit" @click="addAlunoCont">
                    <v-icon left>
                      mdi-content-save
                    </v-icon>
                    Salvar e continuar
                  </v-btn>
                  <v-btn color="error" class="mr-4" v-if="!aluno.id" @click="resetAluno">
                    Limpar
                    <v-icon left>
                      mdi-broom
                    </v-icon>
                  </v-btn>
                  <v-btn color="danger" class="mr-4" @click="closeAluno()">
                    Sair
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-card>
          </template>
        </v-dialog>
      </v-container>
      <v-container>
        <v-dialog v-model="publicar" transition="dialog-top-transition">
          <template v-slot:default="dialog">
            <v-card>
              <v-toolbar color="primary" dark>
                Publicar conteúdo
              </v-toolbar>
              <v-card elevation="2" class="pa-3">
                <div class="ma-5">
                  <PageTitle main="" icon="mdi-pencil-box-outline" sub="Publicar página no site" home="" />
                  <v-form>
                    <v-row>
                      <v-col cols="12" md="2">
                        <v-text-field v-model="codigo" label="Código" dense filled>
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" md="3" v-if="unidade.id">
                        <v-checkbox v-model="unidade.publicar" label="Publicar conteúdo?" color="success"
                          class="mt-0 mb-2" v-show="mode === 'save'"></v-checkbox>
                      </v-col>
                      <v-col cols="12" md="3">
                        <v-menu v-model="menu5" :close-on-content-click="false" :nudge-right="40"
                          transition="scale-transition" offset-y min-width="auto">
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field v-mask="datapub" v-model="data_pub" label="Data de publicacao.:" dense
                              outlined @blur="mudaDataF">
                              <v-icon slot="append" color="success" large v-bind="attrs" v-on="on">
                                mdi-calendar
                              </v-icon>
                            </v-text-field>
                          </template>
                          <v-date-picker locale="pt-br" v-model="date5" @input="dateF">
                          </v-date-picker>
                        </v-menu>
                      </v-col>
                    </v-row>
                  </v-form>
                </div>
                <v-card-actions class="justify-end">
                  <v-btn color="success" class="mr-4" v-if="unidade.id" type="submit" @click="pubConteudo()">
                    <v-icon left>
                      mdi-content-save
                    </v-icon>
                    Salvar
                  </v-btn>
                  <v-btn color="error" class="mr-4" v-if="unidade.id" @click="resetNode">
                    Limpar
                    <v-icon left>
                      mdi-broom
                    </v-icon>
                  </v-btn>
                  <v-btn color="danger" class="mr-4" @click="dialog.value = false">
                    Sair
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-card>
          </template>
        </v-dialog>
      </v-container>
      <!-- Adicionar noticia -->
      <v-container>
        <v-dialog
          v-model="dialogAddNoticia"
          transition="dialog-top-transition"
        >
          <v-card>
            <v-toolbar
              color="primary"
              dark
            >
              Adicionar ou editar notícias à unidade
            </v-toolbar>
            <v-card
              flat
              class="mt-10 mx-2"
            >
              <v-row>
                <input
                  type="hidden"
                  id="id-noticia"
                  v-model="noticia.uid_noticia"
                >
                <input
                  type="hidden"
                  id="uid-unidade"
                  v-model="noticia.uid_page"
                >
                <input
                  type="hidden"
                  id="user"
                  v-model="noticia.usuario"
                >
                <v-col
                  cols="12"
                  md="6"
                >
                  <v-text-field
                    v-model="codeNoticia"
                    label="Código"
                    outlined
                    dense>
                      <v-icon
                        slot="append"
                        color="success"
                        large @click="loadDialogNoticias">
                        mdi-magnify
                      </v-icon>
                  </v-text-field>
                </v-col>
                <v-col
                  v-if="noticia.id"
                  cols="12"
                  md="3"
                >
                  <v-checkbox
                    v-model="noticia.inativar"
                    label="Inativar notícia?"
                    color="success"
                    hide-details
                  >
                  </v-checkbox>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="8">
                  <h3 class="p-2">Título da Notícia.: {{ tituloNoticia }}</h3>
                </v-col>
              </v-row>
              <v-card-actions class="justify-end">
                <v-btn
                  color="success"
                  class="ml-1 mr-4"
                  v-if="!noticia.id"
                  @click.prevent="svsNoticia"
                >
                  <v-icon left>
                    mdi-content-save-outline
                  </v-icon>
                  Salvar e sair
                </v-btn>
                <v-btn
                  color="success"
                  class="ml-1 mr-4"
                  v-if="!noticia.id"
                  @click.prevent="svcNoticia"
                >
                  <v-icon left>
                    mdi-content-save-outline
                  </v-icon>
                  Salvar e continuar
                </v-btn>
                <v-btn
                  color="success"
                  class="ml-1 mr-4"
                  v-if="noticia.id"
                  @click.prevent="saveNoticia"
                >
                  <v-icon left>
                    mdi-content-save-edit-outline
                  </v-icon>
                  Atualizar
                </v-btn>
                <v-btn
                  color="secondary"
                  class="mr-4"
                  @click="resetNoticia()"
                >
                  <v-icon left>
                    mdi-broom
                  </v-icon>
                  Limpar
                </v-btn>
                <v-btn
                  color="danger"
                  class="mr-4"
                  @click="closeDialogNoticia()"
                >
                  Sair
                </v-btn>
                <v-btn
                  v-if="unidade.id"
                  color="error"
                  class="mr-4"
                  @click="removeNoticia"
                >
                  <v-icon left>
                    mdi-trash-can-outline
                  </v-icon>
                  Deletar
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-card>
        </v-dialog>
      </v-container>
      <v-container>
        <v-dialog v-model="vincFoto" transition="dialog-top-transition">
          <template v-slot:default="dialog">
            <v-card>
              <v-toolbar color="primary" dark>
                Vincular url de mídia à unidade
              </v-toolbar>
              <v-card elevation="2" class="pa-3">
                <div class="ma-5">
                  <PageTitle icon="mdi-pencil-box-outline" sub="Imagem de destaque da página" />
                  <v-form>
                    <v-row>
                      <v-col cols="12" lg="9" md="8">
                        <v-container>
                          <v-row>
                            <v-col cols="12" md="12">
                              <v-text-field v-model="url.url_imagem" clearable label="Url da imagem" outlined required
                                dense v-if="mode === 'save'">
                              </v-text-field>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12" md="2">
                              <v-text-field v-model="codigo" label="Código" dense filled>
                              </v-text-field>
                            </v-col>
                            <v-col cols="12" md="2" v-if="unidade.id">
                              <v-checkbox v-model="url.img_vinculada" label="Vincular url?" color="success"
                                class="mt-0 mb-2" v-show="mode === 'save'">
                              </v-checkbox>
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-col>
                      <v-col cols="12" lg="3" md="4">
                        <v-card>
                          <v-img :src="url.url_imagem">
                          </v-img>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-form>
                </div>
                <v-card-actions class="justify-end">
                  <v-btn color="success" class="mr-4" v-if="unidade.id" @click="addImagemCapa()">
                    <v-icon left>
                      mdi-autorenew
                    </v-icon>
                    Sinconizar
                  </v-btn>
                  <v-btn color="danger" class="mr-4" @click="dialog.value = false">
                    Sair
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-card>
          </template>
        </v-dialog>
      </v-container>
    </v-card>
  </div>
</template>

<script>
import PageTitle from '@/components/template/PageTitle'
import Cargos from '@/modules/cadastros/components/cargos'
import FormCat from '../../noticias/forms/FormCat.vue'
import FormSubCat from '../../noticias/forms/formSubCat.vue'
import { mapState } from 'vuex'
import { uuid } from 'vue-uuid'
// import { VueEditor } from 'vue2-editor'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import { baseApiUrl, showError } from '@/global'
import moment from 'moment'
import axios from 'axios'

export default {
  name: 'unidadesAdmin',
  components: { PageTitle, Cargos, FormCat, FormSubCat },
  computed: mapState(['user']),
  data: () => ({
    uuid: '',
    editor: ClassicEditor,
    editorConfig: {},
    datapub: '##/##/####',
    datanex: '##/##/####',
    datamid: '##/##/####',
    cnpj: '##.###.###/####-##',
    fone1: '(##)####-####',
    listar: '',
    tabs: null,
    tabs2: null,
    codigo: '',
    codeMenu: '',
    codeNoticia: '',
    cdComissao: '',
    dialogAddCategoria: false,
    dialogAddSubCategoria: false,
    dialog: false,
    dialogNoticias: false,
    DialogPessoa: false,
    dialogCargo: false,
    addMenus: false,
    addDoc: false,
    addMidia: false,
    addMembro: false,
    DialogConselho: false,
    dialodAddServico: false,
    dialogAddAluno: false,
    dialogAddNoticia: false,
    addVagas: false,
    publicar: false,
    editDoc: false,
    vincFoto: false,
    uploadReady: true,
    date2: new Date().toISOString().substr(0, 10),
    date3: new Date().toISOString().substr(0, 10),
    date4: new Date().toISOString().substr(0, 10),
    date5: new Date().toISOString().substr(0, 10),
    data_publicacao: '',
    menu: false,
    menu2: false,
    menu3: false,
    menu4: false,
    menu5: false,
    menu6: false,
    Gadm: false,
    Galuno: false,
    Gvaga: false,
    data_pub: '',
    data_cad: '',
    data_nasc: '',
    data_anex: '',
    data_mid: '',
    file: '',
    gruponome: '',
    menunome: '',
    tituloNoticia: '',
    tabela: 'unidademidias',
    tabela_doc: 'unidadeanexos',
    search: '',
    mode: 'save',
    unidade: {},
    pessoa: {},
    not: {},
    unidades: [],
    publico: {},
    membros: [],
    conselho: {},
    conselhos: [],
    servico: {},
    servicos: [],
    vaga: {},
    vagas: [],
    aluno: {},
    alunos: [],
    items: [],
    cargos: [],
    menuList: [],
    menuunidade: {},
    membro: {},
    categoria: {},
    noticia: {},
    notice: {},
    subcategoria: {},
    gestoes: [],
    categorias: [],
    subcategorias: [],
    imagem: {},
    capa: {},
    doc: {},
    docs: [],
    midia: {},
    url: {},
    foto: {},
    midias: [],
    length: '',
    grupoMenu: [],
    subMenu: [],
    noticias: [],
    noticiasVinculadas: [],
    parentMenu: [],
    parent: [],
    turmas: [
      { text: 'Bercário', value: 1 },
      { text: 'Maternal I', value: 2 },
      { text: 'Maternal II', value: 3 }
    ],
    targets: [
      { value: '_top', text: '_top' },
      { value: '_self', text: '_self' },
      { value: '_blank', text: '_blank' }
    ],
    headers: [
      {
        text: 'Cód',
        align: 'start',
        sortable: false,
        value: 'id'
      },
      { text: 'Nome da unidades', value: 'unidade' },
      { text: 'Nome', value: 'nome_comum' },
      { text: 'Slug', value: 'slug' },
      {
        text: 'Situação',
        value: 'inativar',
        sortable: false,
        formatter: value => value ? 'Ativo' : 'Inativo'
      },
      { text: 'Ações', value: 'actions', sortable: false }
    ],
    headersMenu: [
      {
        text: 'Código',
        align: 'start',
        sortable: false,
        value: 'id'
      },
      { text: 'Nome', value: 'menu' },
      { text: 'Url int.', value: 'url_int' },
      { text: 'Componente', value: 'component' },
      { text: 'Posição', value: 'posicao' },
      { text: 'Situação', value: 'status', sortable: false },
      { text: 'Ações', value: 'actions', sortable: false }
    ],
    headersMembros: [
      {
        text: 'Cód',
        align: 'start',
        sortable: false,
        value: 'id'
      },
      { text: 'Nome', value: 'agente' },
      { text: 'gestão', value: 'ds_gestao' },
      { text: 'Situação', value: 'situacao', sortable: false },
      { text: 'Ações', value: 'actions', sortable: false }
    ],
    headersConselhos: [
      {
        text: 'Cód',
        align: 'start',
        sortable: false,
        value: 'id'
      },
      { text: 'Nome abrev', value: 'nome' },
      { text: 'Título', value: 'titulo' },
      { text: 'Biênio', value: 'bienio' },
      { text: 'Início', value: 'ano_inicio' },
      { text: 'Término', value: 'ano_termino' },
      { text: 'Situação', value: 'situacao', sortable: false },
      { text: 'Ações', value: 'actions', sortable: false }
    ],
    bienios: [
      { value: 1, text: '1º Biênio' },
      { value: 2, text: '2º Biênio' }
    ],
    headersServicos: [
      {
        text: 'Cód',
        align: 'start',
        sortable: false,
        value: 'id'
      },
      { text: 'Ano', value: 'ano' },
      { text: 'Titulo', value: 'titulo' },
      {
        text: 'Link interno',
        value: 'link_externo',
        sortable: false
      },
      {
        text: 'Ativo',
        value: 'inativar',
        sortable: false,
        formatter: value => value ? 'Sim' : 'Não'
      },
      { text: 'Ações', value: 'actions', sortable: false }
    ],
    headersDoc: [
      {
        text: 'Cód',
        align: 'start',
        sortable: false,
        value: 'id'
      },
      { text: 'Url', value: 'url' },
      { text: 'Ano', value: 'ano' },
      { text: 'Data', value: 'publicacao' },
      {
        text: 'Situação',
        value: 'inativar',
        sortable: false,
        formatter: value => value ? 'Sim' : 'Não'
      },
      { text: 'Ações', value: 'actions', sortable: false }
    ],
    headersNoticias: [
      {
        text: 'Cód',
        align: 'start',
        sortable: false,
        value: 'id'
      },
      { text: 'Título', value: 'titulo' },
      { text: 'Publicado', value: 'publicar', sortable: false },
      { text: 'Data publicação', value: 'data_publicacao' },
      { text: 'Imagem interna', value: 'img_vinculada', sortable: false },
      {
        text: 'Situação',
        value: 'inativar',
        sortable: false,
        formatter: value => value ? 'Ativo' : 'Inativo'
      },
      { text: 'Ações', value: 'actions', sortable: false }
    ],
    headersNoticiasVinculadas: [
      {
        text: 'Cód',
        align: 'start',
        sortable: false,
        value: 'id'
      },
      { text: 'Título da notícia', value: 'titulo' },
      { text: 'Publicada', value: 'publicar' },
      { text: 'Situação', value: 'inativar' },
      { text: 'Ações', value: 'actions', sortable: false }
    ],
    headersVaga: [
      {
        text: 'Cód',
        align: 'start',
        sortable: false,
        value: 'id'
      },
      { text: 'Turma', value: 'turma' },
      { text: 'Quantidade vagas.', value: 'qt_vaga' },
      {
        text: 'Situação',
        value: 'inativar',
        sortable: false,
        formatter: value => value ? 'Sim' : 'Não'
      },
      { text: 'Ações', value: 'actions', sortable: false }
    ],
    headersAluno: [
      {
        text: 'Cód',
        align: 'start',
        sortable: false,
        value: 'id'
      },
      { text: 'Aluno', value: 'aluno' },
      { text: 'Nome da mãe', value: 'n_mae' },
      { text: 'Turma', value: 'turma' },
      { text: 'Ano letivo', value: 'ano_letivo' },
      {
        text: 'Situação',
        value: 'inativar',
        sortable: false,
        formatter: value => value ? 'Sim' : 'Não'
      },
      { text: 'Ações', value: 'actions', sortable: false }
    ],
    headersMid: [
      {
        text: 'Cód',
        align: 'start',
        sortable: false,
        value: 'id'
      },
      { text: 'Url', value: 'url' },
      { text: 'Tam Arq.', value: 'size' },
      { text: 'Data', value: 'publicacao' },
      {
        text: 'Situação',
        value: 'inativar',
        sortable: false,
        formatter: value => value ? 'Sim' : 'Não'
      },
      { text: 'Ações', value: 'actions', sortable: false }
    ],
    valid: false
  }),
  methods: {
    getHtml () {
      let html = this.$refs.toastuiEditor.invoke('getHtml')
      this.unidade.html = html
    },
    mudaDataA () {
      const [dia, mes, ano] = this.data_mid.split('/')
      this.midia.data_publicacao = `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`
    },
    dateA () {
      this.data_mid = moment(this.date2).format('DD/MM/YYYY')
      this.menu2 = false
      const [dia, mes, ano] = this.data_mid.split('/')
      this.midia.data_publicacao = `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`
    },
    dateF () {
      this.data_pub = moment(this.date5).format('DD/MM/YYYY')
      this.menu5 = false
      const [dia, mes, ano] = this.data_pub.split('/')
      this.unidade.data_publicacao = `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`
    },
    dateB () {
      this.data_nasc = moment(this.date3).format('DD/MM/YYYY')
      this.menu3 = false
      const [dia, mes, ano] = this.data_nasc.split('/')
      this.aluno.dt_nascimento = `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`
    },
    mudaDataB () {
      const [dia, mes, ano] = this.data_nasc.split('/')
      this.aluno.dt_nascimento = `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`
    },

    dateE () {
      this.data_cad = moment(this.date4).format('DD/MM/YYYY')
      this.menu4 = false
      const [dia, mes, ano] = this.data_cad.split('/')
      this.conselho.data_publicacao = `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`
    },
    mudaDataE () {
      const [dia, mes, ano] = this.data_cad.split('/')
      this.conselho.data_publicacao = `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`
    },

    mudaDataF () {
      const [dia, mes, ano] = this.data_pub.split('/')
      this.unidade.data_publicacao = `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`
    },
    dateG () {
      this.data_anex = moment(this.date6).format('DD/MM/YYYY')
      this.menu6 = false
      const [dia, mes, ano] = this.data_anex.split('/')
      this.doc.data_publicacao = `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`
    },
    mudaDataG () {
      const [dia, mes, ano] = this.data_anex.split('/')
      this.doc.data_publicacao = `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`
    },
    validate () {
      this.$refs.form.validate()
    },
    loadAdmCampos (id) {
      if (id === 53) this.Gadm = true
      else this.Gadm = false
      if (id === 55) this.Galuno = true
      else this.Galuno = false
      if (id === 57) this.Gvaga = true
      else this.Gvaga = false
    },
    save () {
      if (this.unidade.id) {
        this.unidade.usuario = this.user.id
      }
      const method = this.unidade.id ? 'put' : 'post'
      const id = this.unidade.id ? `/${this.unidade.id}` : ''
      axios[method](`${baseApiUrl}/unidades${id}`, this.unidade)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.loadUpdate()
        })
        .catch(showError)
    },
    saveMenu () {
      const method = this.menuunidade.id ? 'put' : 'post'
      const id = this.menuunidade.id ? `/${this.menuunidade.id}` : ''
      axios[method](`${baseApiUrl}/menus-de-unidades-param${id}`, this.menuunidade)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.resetMenu()
          this.loadMenus()
        })
        .catch(showError)
    },
    delMenu (item) {
      const method = 'delete'
      const id = item.id
      axios[method](`${baseApiUrl}/menus-de-unidades-param/${id}`)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.loadMenus()
        })
        .catch(showError)
    },
    saveDoc () {
      const method = this.doc.id ? 'put' : 'post'
      const id = this.doc.id ? `/${this.doc.id}` : ''
      axios[method](`${baseApiUrl}/doc-param${id}`, this.doc)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.resetDoc()
          this.loadDocs()
        })
        .catch(showError)
    },
    addImagemCapa () {
      const id = this.unidade.uuid
      axios.put(`${baseApiUrl}/add-img-capa-unidade/${id}`, this.url)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.loadUnidade()
        })
        .catch(showError)
    },
    saveMembro () {
      const method = this.membro.id ? 'put' : 'post'
      const id = this.membro.id ? `/${this.membro.id}` : ''
      axios[method](`${baseApiUrl}/membros${id}`, this.membro)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.resetMembro()
          this.loadMembros()
        })
        .catch(showError)
    },
    saveConselho () {
      const method = this.conselho.id ? 'put' : 'post'
      const id = this.conselho.id ? `/${this.conselho.id}` : ''
      axios[method](`${baseApiUrl}/conselhos-e-comissoes${id}`, this.conselho)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.resetConselho()
          this.loadConselhos()
        })
        .catch(showError)
    },
    saveServico () {
      const method = this.servico.id ? 'put' : 'post'
      const id = this.servico.id ? `/${this.servico.id}` : ''
      axios[method](`${baseApiUrl}/servico-param${id}`, this.servico)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.resetServico()
          this.loadServicos()
        })
        .catch(showError)
    },
    saveVaga () {
      const method = this.vaga.id ? 'put' : 'post'
      const id = this.vaga.id ? `/${this.vaga.id}` : ''
      axios[method](`${baseApiUrl}/vagas/cemeis${id}`, this.vaga)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.resetVaga()
          this.loadVagas()
        })
        .catch(showError)
    },
    saveAluno () {
      const method = this.aluno.id ? 'put' : 'post'
      const id = this.aluno.id ? `/${this.aluno.id}` : ''
      axios[method](`${baseApiUrl}/alunos/cemeis${id}`, this.aluno)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.resetAluno()
          this.loadAlunos()
        })
        .catch(showError)
    },
    pubConteudo () {
      this.publico.data_publicacao = this.unidade.data_publicacao
      this.publico.publicar = this.unidade.publicar
      const id = this.unidade.id
      axios.put(`${baseApiUrl}/publicar-unidade/${id}`, this.publico)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.resetNode()
          this.loadUpdate()
          this.publicar = false
        })
        .catch(showError)
    },
    editImagem () {
      this.imagem.data_publicacao_img = this.date1
      const id = this.foto.uuid
      axios.put(`${baseApiUrl}/editar-imagem/${id}`, this.imagem)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.midia = {}
          this.loadMidias()
        })
        .catch(showError)
    },
    saveCat () {
      const method = this.categoria.id ? 'put' : 'post'
      const id = this.categoria.id ? `/${this.categoria.id}` : ''
      axios[method](`${baseApiUrl}/categorias${id}`, this.categoria)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.resetCat()
          this.loadCategorias()
        })
        .catch(showError)
    },
    saveSubCat () {
      const method = this.subcategoria.id ? 'put' : 'post'
      const id = this.subcategoria.id ? `/${this.subcategoria.id}` : ''
      axios[method](`${baseApiUrl}/subcategorias${id}`, this.subcategoria)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.resetSubCat()
          let cat = this.unidade.uid_categoria
          this.loadSubCategorias(cat)
        })
        .catch(showError)
    },
    resetNoticia () {
      this.noticia = {}
      this.codeNoticia = ''
    },
    svsNoticia () {
      this.saveNoticia()
      this.dialogAddNoticia = false
    },
    svcNoticia () {
      this.saveNoticia()
      this.codeNoticia = ''
      this.tituloNoticia = ''
    },
    saveNoticia () {
      const method = this.noticia.id ? 'put' : 'post'
      const id = this.noticia.id ? `/${this.noticia.id}` : ''
      axios[method](`${baseApiUrl}/unidade-da-noticia${id}`, this.noticia)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.noticia.uid_noticia = ''
          this.loadNoticiasVinculadas()
        })
        .catch(showError)
    },
    removeNoticia (item) {
      const id = this.noticia.id || item.id
      if (confirm('Deseja realmente remover a notícia da unidade?')) {
        axios.delete(`${baseApiUrl}/unidade-da-noticia/${id}`)
          .then(() => {
            this.$toasted.global.defaultSuccess()
            this.loadNoticiasVinculadas()
          })
          .catch(showError)
      }
    },
    selectFile () {
      this.file = this.$refs.file.files[0]
    },
    async fileUpload () {
      const formData = new FormData()
      const url = `${baseApiUrl}/upload-de-midia-da-pagina`
      formData.append('uid_pagina', this.midia.uid_unidade)
      formData.append('data_publicacao', this.midia.data_publicacao)
      formData.append('tabela', this.tabela)
      formData.append('pasta', this.unidade.id)
      formData.append('nome', this.midia.nome)
      formData.append('usuario', this.midia.usuario)
      formData.append('file', this.file)
      await axios.post(url, formData)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.loadMidias()
          this.resetUpload()
        })
        .catch(showError)
    },
    async docUpload () {
      const formData = new FormData()
      const url = `${baseApiUrl}/upload-anexos-diversos`
      formData.append('uid_unidade', this.doc.uid_unidade)
      formData.append('data_publicacao', this.doc.data_publicacao)
      formData.append('tabela', this.tabela_doc)
      formData.append('ano', this.doc.ano)
      formData.append('pasta', this.unidade.id)
      formData.append('nome', this.doc.nome)
      formData.append('usuario', this.doc.usuario)
      formData.append('file', this.file)
      await axios.post(url, formData)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.loadDocs()
          this.resetUpload()
        })
        .catch(showError)
    },
    clearUpload () {
      this.uploadReady = false
      this.$nextTick(() => {
        this.uploadReady = true
      })
    },
    resetUpload () {
      this.file = ''
      this.uploadReady = false
      this.$nextTick(() => {
        this.uploadReady = true
      })
      this.resetMidia()
      this.resetDoc()
    },
    remove () {
      alert('Deseja realmente remover?')
    },
    loadUnidades () {
      const url = `${baseApiUrl}/unidades`
      axios.get(url).then(res => {
        this.unidades = res.data
      })
    },
    loadunidadesPai () {
      const url = `${baseApiUrl}/unidades-gestoras-parent`
      axios.get(url).then(res => {
        this.parent = res.data.map(item => {
          return {
            value: item.id,
            text: item.unidade
          }
        })
      })
    },
    loadMidias () {
      const idm = this.unidade.id
      const url = `${baseApiUrl}/midias-da-unidade/${idm}`
      axios.get(url).then(res => {
        this.midias = res.data.map(item => {
          return {
            ...item,
            publicacao: moment(item.data_publicacao).format('DD/MM/YYYY')
          }
        })
      })
    },
    loadNoticias () {
      const url = `${baseApiUrl}/noticias`
      axios.get(url).then(res => {
        this.noticias = res.data
      })
    },
    loadNoticia (item) {
      const url = `${baseApiUrl}/noticias-para-unidade/${item.id}`
      axios.get(url).then(res => {
        this.notice = res.data
        this.noticia.uid_noticia = this.notice.id
        this.codeNoticia = this.notice.id
        this.tituloNoticia = this.notice.titulo
      })
      this.dialogNoticias = false
    },
    loadNoticiasVinculadas () {
      const id = this.unidade.id
      const url = `${baseApiUrl}/noticias-da-unidade-uid/${id}`
      axios.get(url).then(res => {
        this.noticiasVinculadas = res.data.map(item => {
          return {
            ...item,
            inativar: item.inativar === 0 ? 'Ativo' : 'Inativo',
            publicar: item.publicar === 0 ? 'Não' : 'Sim'
          }
        })
      })
    },
    loadMenus () {
      const idB = this.unidade.id
      const url = `${baseApiUrl}/menus-de-unidades-param/${idB}`
      axios.get(url).then(res => {
        this.menuList = res.data
      })
    },
    loadServicos () {
      const idB = this.unidade.id
      const url = `${baseApiUrl}/servicos-por-unidade/${idB}`
      axios.get(url).then(res => {
        this.servicos = res.data
      })
    },
    loadVagas () {
      const url = `${baseApiUrl}/vagas/cemeis-filtro`
      axios.get(url).then(res => {
        this.vagas = res.data
      })
    },
    loadAlunos () {
      const id = this.unidade.id
      const url = `${baseApiUrl}/alunos/cemeis-filtro/${id}`
      axios.get(url).then(res => {
        this.alunos = res.data
      })
    },
    loadMembros () {
      const idB = this.unidade.id
      const url = `${baseApiUrl}/membros-por-unidade/${idB}`
      axios.get(url).then(res => {
        this.membros = res.data.map(item => {
          return {
            ...item,
            situacao: item.inativar === 0 ? 'Ativo' : 'Inativo'
          }
        })
      })
    },
    loadConselhos () {
      const idB = this.unidade.id
      const url = `${baseApiUrl}/conselhos-por-unidade/${idB}`
      axios.get(url).then(res => {
        this.conselhos = res.data.map(item => {
          return {
            ...item,
            situacao: item.inativar === 0 ? 'Ativo' : 'Inativo'
          }
        })
      })
    },
    loadPageConselho (item) {
      this.$router.push({
        name: 'viewConsCom',
        params: { id: item.id }
      })
    },
    loadUnidade (unidade, mode = 'save') {
      this.mode = mode
      const id = unidade.id
      const url = `${baseApiUrl}/unidades-for-update/${id}`
      axios.get(url).then(res => {
        this.unidade = res.data
        let cat = unidade.uid_categoria
        this.loadSubCategorias(cat)
      })
      this.codigo = id
      this.dialog = false
      this.valid = true
    },
    clearUpdate () {
      this.unidade = {}
      this.codigo = ''
    },
    loadUpdate (mode = 'save') {
      this.mode = mode
      this.codigo = this.unidade.id
      const id = this.unidade.id ? `/${this.unidade.id}` : ''
      const url = `${baseApiUrl}/unidades-por-ultimo-id${id}`
      this.clearUpdate()
      axios.get(url).then(res => {
        this.unidade = res.data
      })
    },
    loadMembro (item) {
      this.membro = { ...item }
      this.loadGestoes()
      this.loadCargos()
      this.addMembro = true
      // this.clPessoa()
    },
    loadUrl (foto, mode = 'save') {
      this.mode = mode
      this.foto = { ...foto }
      this.url.url_imagem = this.foto.url
      this.url.img_vinculada = true
      this.vincFoto = true
    },
    loadGestoes () {
      const url = `${baseApiUrl}/gestoes-ativas`
      axios.get(url).then(res => {
        this.gestoes = res.data.map(g => {
          return {
            value: g.id,
            text: (g.ds_gestao + ' com início em ' + (moment(g.data_inicio).format('DD/MM/YYYY')))
          }
        })
      })
    },
    loadCategorias () {
      const url = `${baseApiUrl}/categorias`
      axios.get(url).then(res => {
        this.categorias = res.data.map(cat => {
          return {
            value: cat.id,
            text: cat.categoria
          }
        })
      })
    },
    loadSubCategorias (cat) {
      // const uid = this.unidade.uid_categoria
      const url = `${baseApiUrl}/subcategorias-da-categoria/${cat}`
      axios.get(url).then(res => {
        this.subcategorias = res.data.map(subcat => {
          return {
            value: subcat.id,
            text: subcat.ds_subcategoria
          }
        })
      })
    },
    loadAddCargo () {
      this.dialogCargo = true
    },
    closeDialog () {
      this.dialogCargo = false
      this.loadCargos()
    },
    loadCargos () {
      const url = `${baseApiUrl}/cargos-e-funcoes`
      axios.get(url).then(res => {
        this.cargos = res.data.map(cargos => {
          return {
            value: cargos.id,
            text: `${cargos.cargo}`
          }
        })
      })
    },
    clPessoa () {
      this.membro.uid_agente = ''
      this.membro.agente = ''
      this.items = []
      this.listar = ''
    },
    loadSeach (listar = 'sim') {
      const search = this.membro.agente || 0
      const url = `${baseApiUrl}/agentes-search/${search}`
      axios.get(url).then(res => {
        this.items = res.data
      })
      this.listar = listar
    },
    loadFtPessoa () {

    },
    loadAddPessoa () {
      this.assunto = {}
      this.DialogPessoa = true
    },
    FecharDialog () {
      this.DialogPessoa = false
    },
    loadPedidoPessoaId (item) {
      const id = this.membro.uid_agente ? `/${this.membro.uid_agente}` : `/${item.uid_agente}`
      const url = `${baseApiUrl}/agentes-por-id${id}`
      axios.get(url).then(res => {
        this.pessoa = res.data
        this.membro.uid_agente = this.pessoa.uid_agente
        this.membro.agente = this.pessoa.agente
        // this.membro.uid_agente = this.pessoa.uid_pessoa
      })
      this.clPessoa()
    },
    loadDocs () {
      const idCd = this.unidade.id
      const url = `${baseApiUrl}/arquivos-por-unidade/${idCd}`
      axios.get(url).then(res => {
        this.docs = res.data.map(item => {
          return {
            ...item,
            publicacao: moment(item.data_publicacao).format('DD/MM/YYYY')
          }
        })
      })
    },
    loadDoc (doc, mode = 'save') {
      this.mode = mode
      const idDc = doc.id
      const url = `${baseApiUrl}/doc-param/${idDc}`
      axios.get(url).then(res => {
        this.doc = res.data
      })
      this.editDoc = true
    },
    loadMid (doc, mode = 'save') {
      this.mode = mode
      const idDc = doc.id
      const url = `${baseApiUrl}/doc-param/${idDc}`
      axios.get(url).then(res => {
        this.doc = res.data
      })
      this.editDoc = true
    },
    dialogCategoria () {

    },
    loadAddCategoria () {
      this.categoria.uuid = uuid.v1()
      this.categoria.usuario = this.user.id
      this.dialogAddCategoria = true
    },
    closeDialogCategorias () {
      this.dialogAddCategoria = false
      this.dialogAddSubCategoria = false
    },
    resetCat () {
      this.categoria = {}
    },
    resetSubCat () {
      this.subcategoria = {}
    },
    limparBoxes () {
      this.unidade.uid_categoria = null
      this.unidade.uid_subcategoria = ''
      this.subcategorias = []
    },
    loadAddSubCategoria () {
      this.subcategoria.uuid = uuid.v1()
      this.subcategoria.usuario = this.user.id
      this.subcategoria.uid_categoria = this.unidade.uid_categoria
      this.dialogAddSubCategoria = true
    },
    loadGrupoMenu () {
      const url = `${baseApiUrl}/grupo-de-menus-pa`
      axios.get(url).then(res => {
        this.grupoMenu = res.data.map(item => {
          return {
            value: item.id,
            text: `${item.gp_nome}`
          }
        })
      })
    },
    loadSubMenuSite () {
      const id = this.gruponome
      const url = `${baseApiUrl}/menu-site-pa-grupo/${id}`
      axios.get(url).then(res => {
        this.subMenu = res.data.map(item => {
          return {
            value: item.id,
            text: `${item.nome}`
          }
        })
      })
    },
    loadMenuSite () {
      const id = this.menunome
      const url = `${baseApiUrl}/subgrupo-de-menus-pa/${id}`
      axios.get(url).then(res => {
        this.parentMenu = res.data.map(item => {
          return {
            value: item.id,
            text: `${item.nome}`
          }
        })
      })
    },
    loadMenuAdd () {
      const id = this.menuunidade.uid_menu
      const url = `${baseApiUrl}/menu-site-pa-filtro/${id}`
      axios.get(url).then(res => {
        this.menuunidade = res.data
        this.menuunidade.usuario = this.user.id
        this.menuunidade.uid_unidade = this.unidade.id
      })
    },
    addSairMenu () {
      this.saveMenu()
      this.addMenus = false
    },
    addContMenu () {
      this.saveMenu()
    },
    loadInactiveMenu (item) {
      this.menuunidade.id = item.id
      this.menuunidade.inativar = true
      this.saveMenu()
    },
    loadActiveMenu (item) {
      this.menuunidade.id = item.id
      this.menuunidade.inativar = false
      this.saveMenu()
    },
    loadAddNoticia () {
      this.noticia.uid_page = this.unidade.id
      this.noticia.usuario = this.user.id
      this.dialogAddNoticia = true
    },
    loadUpNoticia (item) {
      const id = item.id
      const url = `${baseApiUrl}/noticia-para-update-por-unidade/${id}`
      axios.get(url).then(res => {
        this.noticia = res.data
        this.tituloNoticia = this.noticia.titulo
        this.codeNoticia = this.noticia.id
      })
      this.dialogAddNoticia = true
    },
    closeDialogNoticia () {
      this.dialogAddNoticia = false
      this.codeNoticia = ''
      this.tituloNoticia = ''
      this.noticia = {}
      this.loadNoticiasVinculadas()
    },
    closeNoticiasFilter () {
      this.search = ''
      this.dialogNoticias = false
    },
    addDcSair () {
      this.saveDoc()
      this.addDoc = false
    },
    addDcCont () {
      this.saveDoc()
    },
    loadServico (servico, mode = 'save') {
      this.mode = mode
      const idL = servico.id
      let id = servico.uid_subcategoria
      let cat = servico.uid_categoria
      const url = `${baseApiUrl}/servicos-update/${idL}`
      axios.get(url).then(res => {
        this.servico = res.data
      })
      this.dialodAddServico = true
      this.loadSubCategorias(cat)
      this.loadAdmCampos(id)
    },
    loadVaga (item) {
      const id = item.id
      const url = `${baseApiUrl}/vagas/cemeis/${id}`
      axios.get(url).then(res => {
        this.vaga = res.data
      })
      this.vaga.usuario = this.user.id
      this.addVagas = true
    },
    loadAluno (item) {
      const id = item.id
      const url = `${baseApiUrl}/alunos/cemeis/${id}`
      axios.get(url).then(res => {
        this.aluno = res.data
      })
      this.aluno.usuario = this.user.id
      this.dialogAddAluno = true
    },
    closeDialogConselho () {
      this.DialogConselho = false
    },
    addConselhoSair () {
      this.saveConselho()
      this.DialogConselho = false
    },
    addConselhoCont () {
      this.saveConselho()
    },
    addMembroSair () {
      this.saveMembro()
      this.addMembro = false
    },
    addMembroCont () {
      this.saveMembro()
    },
    addServicoSair () {
      this.saveServico()
      this.dialodAddServico = false
    },
    addServicoCont () {
      this.saveServico()
    },
    closeServico () {
      this.servico = {}
      this.dialodAddServico = false
    },
    addVagaSair () {
      this.saveVaga()
      this.addVagas = false
    },
    addVagaCont () {
      this.saveVaga()
    },
    addAlunoSair () {
      this.saveAluno()
      this.dialogAddAluno = false
    },
    addAlunoCont () {
      this.saveAluno()
    },
    resetDoc () {
      this.doc = {}
      this.doc.usuario = this.user.id
      this.doc.uuid_unidade = this.unidade.uuid
      this.doc.uid_unidade = this.unidade.id
      this.doc.data_publicacao = ''
    },
    resetMidia () {
      this.midia = {}
      this.midia.usuario = this.user.id
      this.midia.uuid_unidade = this.unidade.uuid
      this.midia.uid_unidade = this.unidade.id
      this.midia.data_publicacao = ''
    },
    resetMenu () {
      this.menuunidade = {}
    },
    resetMembro () {
      this.membro = {}
      this.membro.usuario = this.user.id
      this.membro.uid_unidade = this.unidade.id
    },
    resetConselho () {
      this.conselho = {}
      this.cdComissao = ''
      this.conselho.usuario = this.user.id
      this.conselho.uuid = uuid.v1()
      this.conselho.uid_unidade = this.unidade.id
    },
    resetServico () {
      this.servico = {}
      this.servico.usuario = this.user.id
      this.servico.uid_unidade = this.unidade.id
    },
    resetVaga () {
      this.vaga = {}
      this.vaga.usuario = this.user.id
      this.vaga.uid_servico = this.servico.id
    },
    resetAluno () {
      this.aluno = {}
      this.aluno.usuario = this.user.id
      this.aluno.uid_unidade = this.unidade.id
    },
    closeAluno () {
      this.dialogAddAluno = false
    },
    reset () {
      this.mode = 'save'
      this.foto = {}
      this.unidade = {}
      this.servicos = []
      this.midias = []
      this.membros = []
      this.codigo = ''
      this.loadUser()
      this.loadDatas()
      this.unidade.uuid = uuid.v1()
    },
    loadDialog () {
      this.dialog = true
      this.loadUnidades()
    },
    loadDialogNoticias () {
      this.dialogNoticias = true
      this.loadNoticias()
    },
    loadAddDoc () {
      this.doc = {}
      this.doc.usuario = this.user.id
      this.doc.uuid_unidade = this.unidade.uuid
      this.doc.uid_unidade = this.unidade.id
      this.addDoc = true
    },
    loadAddMid () {
      this.midia = {}
      this.midia.usuario = this.user.id
      this.midia.uuid_unidade = this.unidade.uuid
      this.midia.uid_unidade = this.unidade.id
      this.addMidia = true
    },
    loadAddMenu () {
      this.menuunidade = {}
      this.addMenus = true
      this.loadGrupoMenu()
    },
    closeDialogMenu () {
      this.resetMenu()
      this.addMenus = false
    },
    loadAddMembro () {
      this.membro = {}
      this.membro.usuario = this.user.id
      this.membro.uid_unidade = this.unidade.id
      this.loadGestoes()
      this.loadCargos()
      this.addMembro = true
    },
    loadAddConselho () {
      this.conselho = {}
      this.conselho.usuario = this.user.id
      this.conselho.uuid = uuid.v1()
      this.conselho.uid_unidade = this.unidade.id
      this.DialogConselho = true
    },
    loadAddServico () {
      this.servico.usuario = this.user.id
      this.servico.uid_unidade = this.unidade.id
      this.loadCategorias()
      this.dialodAddServico = true
    },
    loadAddVaga () {
      this.vaga.usuario = this.user.id
      this.vaga.uid_servico = this.servico.id
      this.addVagas = true
    },
    loadAddAluno () {
      this.aluno.usuario = this.user.id
      this.aluno.uid_unidade = this.unidade.id
      this.dialogAddAluno = true
    },
    resetNode () {
      this.mode = 'save'
      this.publico = {}
      this.loadDatas()
    },
    loadPubConteudo () {
      //    this.publico.usuario = this.user.id //implementar na auditoria
      //    this.publico.uid_unidade = this.unidade.uuid // implementar na auditoria
      this.dateG()
      this.publicar = true
    },
    loadUser () {
      this.unidade.uuid = uuid.v1()
      this.unidade.usuario = this.user.id
      this.loadCategorias()
      this.loadunidadesPai()
    },
    loadDatas () {
      const dataAgora = new Date().toISOString().substr(0, 10)
      this.data_criacao = moment(dataAgora).format('DD/MM/YYYY')
      this.date = dataAgora
      this.unidade.usuario = this.user.id
    }
    // (/menus-de-unidades-param)
    // (/menus-de-unidades-param/:id)
    // (/menus-de-unidades-param-update/:id)
    // `id`, `uid_unidade`, `uid_menu`, `chave`, `menu`, `ds_menu`, `posicao`, `inativar`, `created_at`, `updated_at`, `usuario` FROM `menuunidade`
  },
  mounted () {
    this.loadUser()
  }
}
</script>

<style scoped>
.ck.ck-editor__main>.ck-editor__editable {
  min-height: 500px !important;
  max-height: 500px !important;
  border: #830c0c solid 2px;
}

.ck.ck-editor__editable_inline {
  min-height: 500px !important;
  max-height: 500px !important;
  border: #830c0c solid 2px;
}

.ck.ck-editor__main.ck-editor__editable {
  border: #830c0c solid 2px;
  min-height: 200px !important;
}

.v-window__container {
  min-height: 300px !important;
}

.text-v-card {
  font-size: 1rem !important;
}

.codigo {
  max-width: 100% !important;
}

.v-busca-nome {
  max-width: 100% !important;
  height: 45px !important;
}

.v-input__prepend-outer {
  padding: 0px !important;
  width: 36px !important;
  height: 36px !important;
}

.btn-outer {
  margin-top: -7px !important;
  margin-left: -9px !important;
}

.btn-outer-right {
  margin-top: -7px !important;
  margin-right: -11px !important;
}

.v-icon-btn {
  margin-top: -7px !important;
  margin-right: -8px !important;
  padding: auto !important;
  background-color: rgb(12, 94, 46);
}

ul.filtro {
  position: absolute;
  min-width: 350px;
  top: 0px;
  left: 40px;
  padding: 2px 6px !important;
  background-color: #feffff;
  border: solid 1px #000;
  list-style: none;
  z-index: 1000;
}

ul.filtro li a {
  text-decoration: none;
  color: #333 !important;
}

ul.filtro li:hover {
  background-color: teal;
  color: #ffffff !important;
}

ul.filtro li a:hover {
  color: #ffffff !important;
}

.container {
  width: 98% !important;
}

.logo-foto {
  max-width: 750px;
}
</style>
